/*
 *  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IDropdownMenuItem } from "../../../ui/components/DropdownMenu";

export const typedScreenSizeOptions = [
	{
		id: "auto",
		label: "Auto",
		icon: "mdi/overscan"
	},
	{
		id: "wide",
		label: "Wide Desktop",
		icon: "mdi/television"
	},
	{
		id: "desktop",
		label: "Desktop",
		icon: "mdi/desktop-mac"
	},
	{
		id: "tablet",
		label: "Tablet",
		icon: "mdi/tablet-android"
	},
	{
		id: "mobile",
		label: "Phone",
		icon: "mdi/cellphone"
	}
] as const;

export const screenSizeOptions = [ ...typedScreenSizeOptions ] as IDropdownMenuItem[];

export const defaultScreenSizeOption = typedScreenSizeOptions[0];

export type TScreenSizeId = typeof typedScreenSizeOptions[number]["id"];
